import {GenericSystemConfigurationModel, ResponseBaseModel,ApiGenericSystemConfigurationModel} from "../../models";
import {Dispatch, SetStateAction, useEffect, useState} from "react";
import {secureLocalStorageGet, secureLocalStorageSet} from "../../utils";
import {SystemConfiguration} from "../../configuration";
import {getClientGenericConfiguration} from "../../serviceBroker/configurationsApiServiceBroker";
export const useGenericSystemConfigurations = (setLoading?:Dispatch<SetStateAction<boolean>>) => {
    //#region constants
    const defaultValues: GenericSystemConfigurationModel = {
        // Boolean defaults
        RestruantTableRecolerd: false,
        Is_Support_Handel_Mobile_CallApi: false,
        Enable_Add_Item_Image_In_Save_Transaction: false,
        Is_Send_Order_For_Preparing_Screen: false,
        Is_Search_For_Transaction_By_Created_User: false,
        IsPlaySoundOnBarcodeFound: false,
        Is_Enable_Refresh_Timer: false,
        IsEnableToShangeInstallmentPlanAmount: false,
        IsIncludeItemImageInMenuGenratedPdf: false,
        Is_Item_Serial_Requierd: false,
        Is_Item_Serial_Unique: false,
        Is_Save_Transaction_Direct_Connect_To_DB: false,
        Is_Log_Api_Requests: false,
        Is_Distrbute_PriceSale_For_ItemUnit: false,
        Is_Reset_Serial_Of_Order_After_Any_Close_Day: false,
        IsReturnOtherItemUnitsInfoWhenSearchByCachedBarcode: false,
        IsShowItemImageInItemGridTransaction: false,
        IsPrintItemPrescriptionAfterSale: false,
        IsShowCustomerDetailAddressInPrint: false,
        IsFormatNumberToIntIfItIsNotDecimal: false,
        IsPutPnlCustomerInsidePanlButtonPOS: false,
        IsBindGridWithCustomCustomerResult: false,
        IsShowDailogOfButtonNumberOnPOSGrid: false,
        IsEnablePartialPaymentForResturantTable: false,
        IsDirectUploadSalesToeInvoice: false,
        IsEnableToSetSenderEmailAndPassword: false,
        IsSendDetailReportTransactiononEmail: false,
        Is_Get_Category_Code_Depend_On_Parent: false,
        IsSavePurchaseTransactionFromSalesForBalanceLessTHanZero: false,
        IsEnableToSetPriceCoseInTransaction: false,
        IsEnableToUploadAndAttachDocumentInTransaction:false,
        // Number defaults
        Timer_For_Upload_Close_Day_InMinutes: 60,
        Default_Payment_Type_For_Multiple_Payment: 1,
        Timer_For_Preparing_Order_Screen_InSeconds: 30,
        IntervalTimeInMinutesEinvoceSyenc: 10,
        SecondsWaitingToTakeSecondCallOfSameNumber: 60,
        ButtonControlCountInPosScreen: 3,
        FontSizeOfPanelInfoWithCustomer: 0,
        ControlsHieghtOfPnlInfoWithCustomer: 0,
        BackColorReturantTrasnferdTable: 0,
        NumberOfControlsOnShowFormWillDisplyAutoScroll: 50,
        PercentageWidthOfTreeView: 0,
        SecondsWaitingToPushAnotherTransactionToEinvoice: 10,
        DefultTobaccoTaxPercentage: 100,
        MinimumTobaccoTaxValue: 25,
        Due_Date_Installment_Alert: 100,
        MaxFileToUploadInKB: 500,
        // String defaults
        Folder_Path_To_Push_Preparing_Order: "",
        AppleAplicationUrl: "",
        AndroidAplicationUrl: "",
        FilePlaySoundOnBarcodeFound: "",
        EgyptEtaTokenUrl: "",
        ApiServiceDownloadItemMenuOnScanQr: "",
        Service_Local_Uri: "",
        SmallestSizeScreentToShowMaximuzedForm: "",
        ButtonSizePos: "",
        ButtonKeyBoardSizePos: "",
        ButtonSizePosResturant: "",
        ButtonKeyBoardSizePosResturant: "",
        BackColorCategory: "",
        FilesTypeAllowedToUpload: "image/png,image/jpg,image/jpeg,application/pdf",
        // Object defaults
        Installment_Plan: {
            DaysOfInstallmentDistrubite: 30,
            ModValue: 100,
            TransferFractionMoneyToFirstInstallment: true
        },
        Printer_Settings: {
            NumberCopyPrintLocalOrder: 1,
            NumberCopyPrintDeliveryOrder: 1,
            NumberCopyPrintOutOrder: 1
        },

        // Optional properties defaults
        Set_Serial_Pos_Depend_On_Employee: null,
        TrnsactionTypeIdsToShowConsignItemOnly: null,
        TrnsactionTypeIdsToExecludeConsignItem: null,
        CategoryIdsRemoveFromPreparingPrintingReport: null,
        TransactionTypeIdsConfigureToSavePurchaseFromTransaction: null,
        TrnsactionTypeIdsToIncludeGenrateQR: null
    };
    //#endregion
    //#region state
    const [isLoaded, setIsLoaded] = useState(false);
    const [configurations, setConfigurations] = useState<GenericSystemConfigurationModel>(defaultValues);
    //#endregion
    //#region useEffect
    useEffect(() => {
        const fillData = async () => {
            if (setLoading) setLoading(true);
            await fillConfigurations();
            if (setLoading) setLoading(false);
        };
        fillData().then(() => {
        });
    }, []);
    //#endregion
    //#region functions
    const fillConfigurations = async ()=>{
        setIsLoaded(false);
        const cachedResponse=secureLocalStorageGet(SystemConfiguration.cacheKey_Configurations.setting.genericSystemConfiguration);
        if(cachedResponse !=null) {
            setConfigurations(JSON.parse(cachedResponse as string) as GenericSystemConfigurationModel);
        }
        else{

            const response: ResponseBaseModel<ApiGenericSystemConfigurationModel[]> = await getClientGenericConfiguration();
            const configurations =mapApiResponseToConfig(response);
            secureLocalStorageSet(SystemConfiguration.cacheKey_Configurations.setting.genericSystemConfiguration, JSON.stringify(configurations));
            setConfigurations(configurations);
        }
        setIsLoaded(true);
    }
    function mapApiResponseToConfig(apiResponse: ResponseBaseModel<ApiGenericSystemConfigurationModel[]>): GenericSystemConfigurationModel {
        // Start with default values
        const config: GenericSystemConfigurationModel = { ...defaultValues };

        // If the API call failed, just return defaults
        if (!apiResponse || !apiResponse.Result) {
            return config;
        }

        // Get the config items array (no need to check if it's array since we're expecting an array)
        const configItems: ApiGenericSystemConfigurationModel[] = apiResponse.Result;

        // Process each config item
        configItems.forEach(item => {
            // Check if this property exists in our model
            const propertyName = item.Code as keyof GenericSystemConfigurationModel;
            if (!(propertyName in config)) return;

            // Get the expected type and default value for this property
            const expectedType = typeof config[propertyName];
            const defaultForThisProperty = defaultValues[propertyName];

            // Handle object properties separately to avoid type issues
            if (expectedType === 'object' && defaultForThisProperty !== null) {
                try {
                    if (typeof item.Config_Value === 'string') {
                        (config as any)[propertyName] = JSON.parse(item.Config_Value);
                    } else {
                        (config as any)[propertyName] = defaultForThisProperty;
                    }
                } catch {
                    // Fall back to default on parsing error
                    (config as any)[propertyName] = defaultForThisProperty;
                }
            } else {
                // For primitive types, use the conversion helper
                // Use type assertion to avoid type errors
                (config as any)[propertyName] = convertValue(
                    item.Config_Value,
                    expectedType,
                    defaultForThisProperty,
                    propertyName as string
                );
            }
        });

        return config;
    }
    function convertValue(value: any, expectedType: string, defaultValue: any, propertyName?: string): any {
        // If the value is already of the expected type, return it
        if (typeof value === expectedType) {
            return value;
        }

        // Handle string conversions
        if (typeof value === 'string') {
            // Convert to boolean
            if (expectedType === 'boolean') {
                return value.toLowerCase() === 'true';
            }

            // Convert to number
            if (expectedType === 'number') {
                const num = Number(value);
                return isNaN(num) ? defaultValue : num;
            }

            //// Handle comma-separated string conversion to array of numbers or strings
            // if (value.includes(',')) {
            //     // List of properties that should be converted to arrays of numbers
            //     const numberArrayProperties = [
            //         'TrnsactionTypeIdsToIncludeGenrateQR',
            //         'TrnsactionTypeIdsToShowConsignItemOnly',
            //         'TrnsactionTypeIdsToExecludeConsignItem',
            //         'CategoryIdsRemoveFromPreparingPrintingReport',
            //         'BackColorCategory'
            //     ];
            //
            //     // Split the string by commas
            //     const items = value.split(',').map(item => item.trim());
            //
            //     // If this is a property that should be an array of numbers
            //     if (propertyName && numberArrayProperties.includes(propertyName)) {
            //         return items.map(item => {
            //             const num = Number(item);
            //             return isNaN(num) ? 0 : num;
            //         });
            //     }
            //
            //     // Otherwise return as string array
            //     return items;
            // }

            const numberArrayProperties = [
                'TrnsactionTypeIdsToIncludeGenrateQR',
                'TrnsactionTypeIdsToShowConsignItemOnly',
                'TrnsactionTypeIdsToExecludeConsignItem',
                'CategoryIdsRemoveFromPreparingPrintingReport',
                'TransactionTypeIdsConfigureToSavePurchaseFromTransaction',
            ];
            if (propertyName &&
                numberArrayProperties.includes(propertyName) &&
                value.includes(',') &&
                expectedType === 'object') {
                const items = value.split(',').map(item => item.trim());
                return items.map(item => {
                    const num = Number(item);
                    return isNaN(num) ? 0 : num;
                });
            }

            // Convert to object (JSON)
            if (expectedType === 'object') {
                try {
                    return JSON.parse(value);
                } catch {
                    // If propertyName is one of our array properties but parsing failed,
                    // try treating it as a comma-separated list
                    if (propertyName &&
                        numberArrayProperties.includes(propertyName) &&
                        value.includes(',')) {

                        console.log(`Converting comma-separated list in catch block for property: ${propertyName}`);
                        const items = value.split(',').map(item => item.trim());
                        return items.map(item => {
                            const num = Number(item);
                            return isNaN(num) ? 0 : num;
                        });
                    }
                    return defaultValue;
                }
            }
        }

        // If we reach here, conversion failed or wasn't possible
        // Return the default value which should match the expected type
        return defaultValue;
    }
//#endregion
    return {
        genericSystemConfigurations:configurations as GenericSystemConfigurationModel ,
        isConfigurationLoaded:isLoaded
    };
}


